import * as React from 'react';
import { SVGProps } from 'react';

const IconFitToDefaultSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 3H3v18h6v-2H5V5h4V3zm6 0h6v18h-6v-2h4V5h-4V3z" />
  </svg>
);
export default IconFitToDefaultSizeM;
